import { render, staticRenderFns } from "./AddAdvisorySchool.vue?vue&type=template&id=6c3eebce&scoped=true"
import script from "./AddAdvisorySchool.vue?vue&type=script&lang=js"
export * from "./AddAdvisorySchool.vue?vue&type=script&lang=js"
import style0 from "./AddAdvisorySchool.vue?vue&type=style&index=0&id=6c3eebce&prod&scoped=true&lang=css"
import style1 from "./AddAdvisorySchool.vue?vue&type=style&index=1&id=6c3eebce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3eebce",
  null
  
)

export default component.exports